import { InfoCircleOutlined } from '@ant-design/icons'
import { Col, Row } from 'antd'
import Alert from 'app/components/UI-Elements/Feedback/Alert'
import useTranslation from 'app/lib/hooks/useTranslation'
import { RecordTypeEnum } from 'app/queries'

const DeliveryAddressHint: React.FC = () => {
  const { tCore } = useTranslation({
    scope: 'info',
    recordType: RecordTypeEnum.rentalDeliveryAddress
  })

  return (
    <Row gutter={[0, 12]}>
      <Col span={24}>
        <Alert
          icon={<InfoCircleOutlined className="pt-2 warning" />}
          showIcon={true}
          type={'transparent'}
          className="px-0"
          message={undefined}
          description={<p className="mb-0">{tCore({ id: 'description' })}</p>}
        />
      </Col>
    </Row>
  )
}
export default DeliveryAddressHint
